(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bahama-bucket"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.bahama-bucket').forEach(function(root) {
    var main    = root.querySelector('[data-bk-main]');
    var counter = root.querySelector('[data-bk-counter]');
    var thumbs  = Array.prototype.slice.call(root.querySelectorAll('.bk-thumb'));
    function activate(idx) {
      var t = thumbs[idx];
      if (!t) return;
      thumbs.forEach(function(x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      var src = t.getAttribute('data-bk-img');
      if (main && src) main.setAttribute('src', src);
      if (counter) counter.textContent = idx + 1;
      t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    thumbs.forEach(function(t, idx) {
      t.addEventListener('click', function() { activate(idx); });
    });
    function step(delta) {
      var current = thumbs.indexOf(root.querySelector('.bk-thumb.is-active'));
      if (current < 0) current = 0;
      activate((current + delta + thumbs.length) % thumbs.length);
    }
    var gPrev = root.querySelector('[data-bk-prev]');
    var gNext = root.querySelector('[data-bk-next]');
    if (gPrev) gPrev.addEventListener('click', function(e) { e.stopPropagation(); step(-1); });
    if (gNext) gNext.addEventListener('click', function(e) { e.stopPropagation(); step(1); });
    var sticky = root.querySelector('[data-bk-sticky]');
    var stickyBtn = root.querySelector('[data-bk-sticky-btn]');
    var form = root.querySelector('[data-bk-form]');
    if (stickyBtn && form) stickyBtn.addEventListener('click', function() { var s = form.querySelector('button[type=submit]'); if (s) s.click(); });
    if (sticky && form && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) { entries.forEach(function(e) { sticky.classList.toggle('is-visible', !e.isIntersecting); }); }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });
      io.observe(form);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bahama-lab-article"] && !Shopify.designMode) return;
  try {
    
(function() {
  var bar = document.querySelector('[data-bp-progress]');
  if (bar) {
    window.addEventListener('scroll', function() {
      var h = document.documentElement;
      var pct = (h.scrollTop) / (h.scrollHeight - h.clientHeight) * 100;
      bar.style.width = pct + '%';
    });
  }

  // Hide author-side placeholder lines like "📷 Upload image: foo.jpg" inside articles.
  document.querySelectorAll('.bp-prose p').forEach(function(p) {
    var t = (p.textContent || '').trim();
    if (/^(?:📷|📸|🎥|🎞)?\s*Upload (image|video|photo|file)\s*:/i.test(t)) {
      p.style.display = 'none';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bahama-pdp"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Subscribe & Save only applies to the single bottle. Bundles (Full System Set,
  // Garage Kit) are one-time only, so hide the subscribe block and reset the form
  // to one-time whenever a non-single option is the active selection.
  function syncSubscribeForOpt(opt) {
    var sub = document.querySelector('[data-bp-subscribe]');
    if (!sub) return;
    var isSingle = (opt === 'single');
    sub.style.display = isSingle ? '' : 'none';
    if (!isSingle) {
      var otp = sub.querySelector('[data-bp-mode][value="otp"]');
      if (otp) otp.checked = true;
      var hidden = sub.querySelector('[data-bp-selling-plan]');
      if (hidden) hidden.value = '';
    }
  }

  // Bundle radio toggle (visual only, plus optional href redirect)
  document.querySelectorAll('[data-bp-bundle] .bp-bopt').forEach(function(opt) {
    opt.addEventListener('click', function(e) {
      var target = opt.getAttribute('data-bp-target');
      // If a target URL is set (i.e. bundle/garage product), navigate to it
      if (target) {
        e.preventDefault();
        window.location.href = target;
        return;
      }
      var parent = opt.closest('[data-bp-bundle]');
      parent.querySelectorAll('.bp-bopt').forEach(function(o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
      var radio = opt.querySelector('input[type=radio]');
      if (radio) radio.checked = true;
      syncSubscribeForOpt(opt.getAttribute('data-bp-opt'));
    });
  });

  // Set initial subscribe visibility from the default-selected picker option.
  document.querySelectorAll('[data-bp-bundle]').forEach(function(parent) {
    var sel = parent.querySelector('.bp-bopt.selected');
    if (sel) syncSubscribeForOpt(sel.getAttribute('data-bp-opt'));
  });

  // Filter chips (visual only)
  document.querySelectorAll('[data-bp-chips] .bp-chip').forEach(function(chip) {
    chip.addEventListener('click', function() {
      var siblings = chip.parentElement.querySelectorAll('.bp-chip');
      siblings.forEach(function(c) { c.classList.remove('active'); });
      chip.classList.add('active');
    });
  });

  // Gallery thumb swap + counter + click-through on main image
  document.querySelectorAll('.bp-gallery').forEach(function(g) {
    var main = g.querySelector('.bp-gallery__image');
    var mainWrap = g.querySelector('.bp-gallery__main');
    var video = g.querySelector('[data-bp-gallery-video]');
    var counter = g.querySelector('[data-bp-gallery-counter]');
    var thumbs = g.querySelectorAll('.bp-gallery__thumb');
    if (!thumbs.length) return;

    function activate(idx) {
      var t = thumbs[idx];
      if (!t) return;
      thumbs.forEach(function(x) { x.classList.remove('is-active', 'active'); });
      t.classList.add('is-active');
      if (t.getAttribute('data-media-type') === 'video' && video) {
        var vsrc = t.getAttribute('data-video-src');
        if (vsrc) {
          if (video.getAttribute('src') !== vsrc) video.setAttribute('src', vsrc);
          var poster = t.getAttribute('data-poster');
          if (poster) video.setAttribute('poster', poster);
          if (main) main.style.display = 'none';
          video.style.display = 'block';
          video.play().catch(function() {});
        }
      } else {
        if (video) { video.pause(); video.style.display = 'none'; }
        var src = t.getAttribute('data-img-src');
        if (main) {
          main.style.display = '';
          if (src) {
            main.classList.add('is-swapping');
            main.setAttribute('src', src);
            requestAnimationFrame(function() { requestAnimationFrame(function() { main.classList.remove('is-swapping'); }); });
          }
        }
      }
      if (counter) counter.textContent = idx + 1;
    }

    thumbs.forEach(function(t, idx) {
      t.addEventListener('click', function() { activate(idx); });
    });

    function step(delta) {
      var current = Array.prototype.indexOf.call(thumbs, g.querySelector('.bp-gallery__thumb.is-active'));
      if (current < 0) current = 0;
      var next = (current + delta + thumbs.length) % thumbs.length;
      activate(next);
    }

    var prev = g.querySelector('[data-bp-gallery-prev]');
    var next = g.querySelector('[data-bp-gallery-next]');
    if (prev) prev.addEventListener('click', function(e) { e.stopPropagation(); step(-1); });
    if (next) next.addEventListener('click', function(e) { e.stopPropagation(); step(1); });
  });

  document.querySelectorAll('[data-bp-waitlist]').forEach(function(box) {
    var form = box.querySelector('form'), input = box.querySelector('input[type=email]');
    var msg = box.querySelector('[data-bp-waitlist-msg]'), btn = box.querySelector('button[type=submit]');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      msg.classList.remove('is-error');
      if (!email || email.indexOf('@') < 1) { msg.textContent = 'Enter a valid email address.'; msg.classList.add('is-error'); return; }
      btn.disabled = true; msg.textContent = 'Adding you...';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(box.dataset.company), {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } },
          relationships: { list: { data: { type: 'list', id: box.dataset.list } } } } })
      }).then(function(r) {
        if (r.ok || r.status === 202) { msg.textContent = 'You are on the list. We will email you the moment it drops.'; form.style.display = 'none'; }
        else { msg.textContent = 'Something went wrong. Please try again.'; msg.classList.add('is-error'); btn.disabled = false; }
      }).catch(function() { msg.textContent = 'Something went wrong. Please try again.'; msg.classList.add('is-error'); btn.disabled = false; });
    });
  });

  // Subscribe & save: sync hidden selling_plan with radio + frequency dropdown
  document.querySelectorAll('[data-bp-subscribe]').forEach(function(container) {
    var hidden = container.querySelector('[data-bp-selling-plan]');
    var freq = container.querySelector('[data-bp-frequency]');
    var modes = container.querySelectorAll('[data-bp-mode]');
    if (!hidden) return;
    function sync() {
      var checked = container.querySelector('[data-bp-mode]:checked');
      var isSub = checked && checked.value === 'sub';
      hidden.value = (isSub && freq) ? freq.value : '';
    }
    modes.forEach(function(r) { r.addEventListener('change', sync); });
    if (freq) {
      // When the dropdown is opened or changed, auto-select Subscribe
      ['mousedown', 'focus', 'change'].forEach(function(ev) {
        freq.addEventListener(ev, function() {
          var sub = container.querySelector('[data-bp-mode][value="sub"]');
          if (sub && !sub.checked) sub.checked = true;
          sync();
        });
      });
    }
    sync();
  });

  // Paired-towel add-on: when ticked, submit the bottle and the towel as one /cart/add request
  document.querySelectorAll('[data-bp-atc-form]').forEach(function(form) {
    form.addEventListener('submit', function() {
      var checked = Array.prototype.filter.call(form.querySelectorAll('[data-bp-addon]'), function(c) { return c.checked; });
      if (!checked.length) return;
      if (form.querySelector('[name="items[1][id]"]')) return;
      var id = form.querySelector('input[name="id"]');
      if (id) { id.name = 'items[0][id]'; }
      var qty = form.querySelector('input[name="quantity"]');
      if (qty) { qty.name = 'items[0][quantity]'; }
      var sp = form.querySelector('input[name="selling_plan"]');
      if (sp && sp.value) { sp.name = 'items[0][selling_plan]'; }
      checked.forEach(function(cb, n) {
        var a = document.createElement('input'); a.type = 'hidden'; a.name = 'items[' + (n + 1) + '][id]'; a.value = cb.value;
        var aq = document.createElement('input'); aq.type = 'hidden'; aq.name = 'items[' + (n + 1) + '][quantity]'; aq.value = '1';
        form.appendChild(a); form.appendChild(aq);
      });
    });
  });

  // Sticky ATC: trigger main ATC form on click
  document.querySelectorAll('[data-bp-sticky-atc-btn]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var form = document.querySelector('[data-bp-atc-form]');
      if (form) form.querySelector('button[type=submit]').click();
    });
  });

  // Sticky ATC: show after the buy-box ATC scrolls out of view; hide when it scrolls back in
  var sticky = document.querySelector('[data-bp-sticky-atc]');
  var trigger = document.querySelector('[data-bp-atc-form]');
  if (sticky && trigger && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('is-visible');
        } else {
          sticky.classList.add('is-visible');
        }
      });
    }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });
    io.observe(trigger);
  } else if (sticky) {
    sticky.classList.add('is-visible');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bahama-towel"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.bk-gallery').forEach(function(g){
    var main    = g.querySelector('[data-bk-main]');
    var vid     = g.querySelector('[data-bk-video-el]');
    var counter = g.querySelector('[data-bk-counter]');
    var thumbs  = Array.prototype.slice.call(g.querySelectorAll('.bk-thumb'));
    if (!thumbs.length) return;

    function activate(idx) {
      var btn = thumbs[idx];
      if (!btn) return;
      thumbs.forEach(function(b){ b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var src = btn.getAttribute('data-bk-video');
      if (btn.getAttribute('data-media-type') === 'video' && src && vid) {
        if (vid.getAttribute('src') !== src) vid.setAttribute('src', src);
        var poster = btn.getAttribute('data-poster');
        if (poster) vid.setAttribute('poster', poster);
        if (main) main.style.visibility = 'hidden';
        vid.style.display = 'block';
        vid.play().catch(function(){});
      } else {
        if (vid) { vid.pause(); vid.style.display = 'none'; }
        if (main) { main.style.visibility = 'visible'; main.src = btn.getAttribute('data-bk-img'); }
      }
      if (counter) counter.textContent = idx + 1;
      btn.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    thumbs.forEach(function(btn, idx){
      btn.addEventListener('click', function(){ activate(idx); });
    });

    function step(delta) {
      var current = thumbs.indexOf(g.querySelector('.bk-thumb.is-active'));
      if (current < 0) current = 0;
      activate((current + delta + thumbs.length) % thumbs.length);
    }
    var prev = g.querySelector('[data-bk-prev]');
    var next = g.querySelector('[data-bk-next]');
    if (prev) prev.addEventListener('click', function(e){ e.stopPropagation(); step(-1); });
    if (next) next.addEventListener('click', function(e){ e.stopPropagation(); step(1); });
  });

  // Proof video. The src and autoplay live in the markup so playback never depends on JS.
  // This only pauses it while off screen, and is purely an optimisation.
  document.querySelectorAll('[data-bk-proof]').forEach(function(sec){
    var v = sec.querySelector('[data-bk-proof-video]');
    if (!v || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { v.play().catch(function(){}); }
        else { v.pause(); }
      });
    }, { rootMargin: '300px 0px', threshold: 0.01 }).observe(sec);
  });

  document.querySelectorAll('[data-bk-form]').forEach(function(form){
    form.addEventListener('submit', function(e){
      var cb = form.querySelector('[data-bk-addon]');
      if (!cb || !cb.checked) return;              // unchecked = plain single-item add
      if (form.querySelector('[name="items[1][id]"]')) return;
      // switch to the /cart/add items[] shape so both land in one request
      var id = form.querySelector('input[name="id"]');
      if (id) { id.name = 'items[0][id]'; }
      var qty = form.querySelector('input[name="quantity"]');
      if (qty) { qty.name = 'items[0][quantity]'; }
      var a = document.createElement('input'); a.type='hidden'; a.name='items[1][id]'; a.value=cb.value;
      var aq = document.createElement('input'); aq.type='hidden'; aq.name='items[1][quantity]'; aq.value='1';
      form.appendChild(a); form.appendChild(aq);
    });
  });

  document.querySelectorAll('.bahama-bucket').forEach(function(root) {
    var main = root.querySelector('[data-bk-main]');
    root.querySelectorAll('.bk-thumb').forEach(function(t) {
      t.addEventListener('click', function() {
        root.querySelectorAll('.bk-thumb').forEach(function(x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-bk-img');
        if (main && src) main.setAttribute('src', src);
      });
    });
    var sticky = root.querySelector('[data-bk-sticky]');
    var stickyBtn = root.querySelector('[data-bk-sticky-btn]');
    var form = root.querySelector('[data-bk-form]');
    if (stickyBtn && form) stickyBtn.addEventListener('click', function() { var s = form.querySelector('button[type=submit]'); if (s) s.click(); });
    if (sticky && form && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) { entries.forEach(function(e) { sticky.classList.toggle('is-visible', !e.isIntersecting); }); }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });
      io.observe(form);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
